import {useIdentityUserSearch} from '@domain/user'
import {UserSearchAutocomplete} from '@hconnect/common/components/formFields'
import {User} from '@hconnect/common/types'
import {FC, useMemo, useState} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import {AssignedUser} from '../../types'
import {FieldErrors} from '../../validation'

type ResponsibleUserSearchProps = {
  setAssignedUsers: React.Dispatch<React.SetStateAction<AssignedUser[]>>
  assignedUser: AssignedUser
  index: number
  errors: FieldErrors
}

export const ResponsibleUserSearch: FC<ResponsibleUserSearchProps> = ({
  assignedUser,
  setAssignedUsers,
  index,
  errors
}) => {
  const [search, setSearch] = useState<string>()
  const [user, setUser] = useState<User | undefined>({
    id: assignedUser.userId,
    name: assignedUser.name
  })
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const {data, isFetching} = useIdentityUserSearch(search, {enabled: search !== user?.name})

  const users = useMemo<User[]>(() => {
    if (!data) return []
    return data.map((d) => ({name: d.name, id: d.user_id}))
  }, [data])

  const handleOnUserChange = (value: User | User[] | null) => {
    if (!value || Array.isArray(value)) return
    setAssignedUsers((prev) =>
      prev.map((user, i) => (i === index ? {...user, userId: value.id, name: value.name} : user))
    )
    setUser(value)
  }

  const handleInputChange = (searchTerm: string) => {
    setSearch(searchTerm)
  }

  return (
    <UserSearchAutocomplete
      value={user}
      error={errors.responsibleUserIds && !!errors.responsibleUserIds[assignedUser.id]}
      label={t('responsiblePersonDialog.label.user')}
      name="user-search"
      onInputChange={handleInputChange}
      id={`expert-system-user-search-${index}`}
      data-test-id={`expert-system-user-search-${index}`}
      query={{data: users, isFetching}}
      helperText={
        errors.responsibleUserIds && errors.responsibleUserIds[assignedUser.id]
          ? t('responsiblePersonDialog.error.responsibleUserRequired')
          : ''
      }
      onChange={(_, value) => handleOnUserChange(value)}
    />
  )
}
